import React from 'react';
import { Layout } from 'fronton-react';
import {
  HeaderSection,
  OtherSection,
  RootLayout,
} from 'common/components';
import { useIsInViewport, useScrollToElement } from 'common/hooks';
import { ConsultationSection } from 'remotes/consultation-section';
import { PromoBlock } from 'remotes/promo-block';
import { SpecialOffer } from 'remotes/special-offer';
import {
  ENTRANCE_DOORS_CDN_PATH,
  ENTRANCE_DOORS_ELEMENT_BLOCK,
  ENTRANCE_DOORS_LANDING_NAME,
  ENTRANCE_DOORS_PATH,
} from './entrance-doors-constants';
import {
  EntranceDoorsApartmentSection,
  EntranceDoorsBenefits,
  EntranceDoorsDesignPanel,
  EntranceDoorsGallerySection,
  EntranceDoorsHouseSection,
  EntranceDoorsSpecialSection,
  EntranceDoorsUtpSection,
} from './components';

export const EntranceDoors = () => {
  const { elRef, onScrollToElement } = useScrollToElement();
  const isConsultationFormVisible = useIsInViewport(elRef, { threshold: 0 });

  return (
    <RootLayout currentPage={ENTRANCE_DOORS_PATH}>
      <HeaderSection
        bgColor="#7C655C"
        description="Подберём двери и&nbsp;аксессуары под любой интерьер. Позаботимся о&nbsp;всех этапах&nbsp;&mdash; от&nbsp;замера до&nbsp;установки."
        img={{
          ldSrcSet: `${ENTRANCE_DOORS_CDN_PATH}/header/header-ld-new.jpg/header-ld-new.jpg`,
          dSrcSet: `${ENTRANCE_DOORS_CDN_PATH}/header/header-d.jpg/header-d.jpg`,
          tSrcSet: `${ENTRANCE_DOORS_CDN_PATH}/header/header-t-new.jpg/header-t-new.jpg`,
          mSrcSet: `${ENTRANCE_DOORS_CDN_PATH}/header/header-m.jpg/header-m.jpg`,
          title: 'Входные двери на заказ',
          alt: 'Входные двери на заказ',
        }}
        mediaType="image"
        title="Входные двери на&nbsp;заказ"
      />
      <EntranceDoorsDesignPanel
        isConsultationFormVisible={isConsultationFormVisible}
        onConsultationSignupBtnClick={onScrollToElement}
      />
      <Layout>
        <PromoBlock elementBlock={ENTRANCE_DOORS_ELEMENT_BLOCK} />
        <SpecialOffer onModalBtnClick={onScrollToElement} elementBlock={ENTRANCE_DOORS_ELEMENT_BLOCK} />
        <EntranceDoorsBenefits />
        <EntranceDoorsUtpSection onConsultationSignupBtnClick={onScrollToElement} />
        <EntranceDoorsHouseSection onConsultationSignupBtnClick={onScrollToElement} />
        <EntranceDoorsApartmentSection onConsultationSignupBtnClick={onScrollToElement} />
        <EntranceDoorsSpecialSection />
        <EntranceDoorsGallerySection onConsultationSignupBtnClick={onScrollToElement} />
        <ConsultationSection
          consultationType="ENTRANCE_DOOR"
          elementBlock={ENTRANCE_DOORS_ELEMENT_BLOCK}
          elementText="Заявка на консультацию и замер"
          isCommentVisible
          sectionRef={(el: HTMLElement | null) => {
            elRef.current = el;
          }}
          sectionText="Отправьте заявку, мы&nbsp;перезвоним в&nbsp;ближайшее время, бесплатно проконсультируем и&nbsp;запишем на&nbsp;замер."
          sectionTitle="Заявка на консультацию и&nbsp;замер"
        />
      </Layout>
      <OtherSection
        elementBlock={`${ENTRANCE_DOORS_ELEMENT_BLOCK} / other`}
        landingName={ENTRANCE_DOORS_LANDING_NAME}
        promotionName={`${ENTRANCE_DOORS_ELEMENT_BLOCK}_bottom`}
      />
    </RootLayout>
  );
};
